import { EducationLevelModel } from '../../../shared/models/education-level-model';
import { JobseekerFile } from './jobseeker-file';
import { Serializable } from '../../../core/models/serializable';
import { EducationalInstitutionModel } from '@admin/shared/models/educational-institution-model';
import { EducationalProgramModel } from '@admin/shared/models/educational-program-model';
export class JobseekerEducationModel
  implements Serializable<JobseekerEducationModel>
{
  fromObject(obj: any): JobseekerEducationModel {
    Object.assign(this, obj);
    this.attachment = null;
    this.educationLevel = null;

    if (obj.attachment != null) {
      let t = new JobseekerFile();
      t = t.fromObject(obj.attachment);
      this.attachment = t;
    }

    if (obj.educationLevel != null) {
      let t = new EducationLevelModel();
      t = t.fromObject(obj.educationLevel);
      this.educationLevel = t;
    }

    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseekerEducationId: number;
  public jobseekerId: number;
  public educationalInstitution: EducationalInstitutionModel;
  public educationalProgram: EducationalProgramModel;
  public educationalProgramName: string;
  public educationLevel: EducationLevelModel;
  public attachment: JobseekerFile;
  public dateFromYear: number;
  public dateFromMonth: number;
  public dateToYear: number;
  public dateToMonth: number;
  public institution: string;
  public specialization: string;
  public description: string;
}
